export default "__VITE_ASSET__BEBxVhe7__"